// CustomerSlice.js
import { createSlice } from '@reduxjs/toolkit';
import {editProfile, fetchCustomer } from '../../services/userService';

const customerSlice = createSlice({
    name: 'customer',
    initialState: {
        errors : [],
        loader : false,
        isSuccess: false,
        customer : null
    },
    reducers: {},
    extraReducers : (builder) => {
        builder
          .addCase(editProfile.pending, (state) => {
            state.loader = true;
            state.isSuccess = false;
            state.errors = null;
          })
          .addCase(editProfile.fulfilled, (state, action) => {
            state.loader = false;
            state.isSuccess = true;
          })
          .addCase(editProfile.rejected, (state, action) => {
            state.loader = false;
            state.isSuccess = false;
            state.errors = action.payload;
          })
          .addCase(fetchCustomer.pending, (state) => {
            state.loader = true;
           // state.isSuccess = false;
            state.errors = null;
          })
          .addCase(fetchCustomer.fulfilled, (state, action) => {
            state.loader = false;
            //state.isSuccess = true;
            state.customer = action.payload;
          })
          .addCase(fetchCustomer.rejected, (state, action) => {
            state.loader = false;
            //state.isSuccess = false;
            state.errors = action.payload;
          });
    }
});

export const {} = customerSlice.actions;
export default customerSlice.reducer;
